<label for="fileUpload" [ngClass]="{ fileOver: isDraggingFileOver }">
	<span>{{ labels.lbl_importar_arquivos }}</span>
	<span><fa-icon [icon]="icons.faUpload"></fa-icon></span>
	<input
		type="file"
		name="fileUpload"
		(dragenter)="isDraggingFileOver = true"
		(dragleave)="isDraggingFileOver = false"
		(change)="handleFile($event)"
		id="fileUpload" />
</label>

<div class="added-files-container">
	<div class="dotted-input-container file" *ngFor="let file of mspFileList; let index = index">
		<span>{{ file.name }}</span>
		<div class="button-container">
			<span (click)="removeFile(index)"><fa-icon [icon]="icons.faTimes"></fa-icon></span>
		</div>
	</div>

	<cpi-dot-bounce-loading-effect [color]="'var(--black)'" *ngIf="isConvertingFile"></cpi-dot-bounce-loading-effect>
</div>
